import React from "react";
import { useTranslation } from "react-i18next";
import { HashLink } from "react-router-hash-link";
import { Helmet } from "react-helmet-async";

const DentalImplants = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="container py-5 mt-5" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/dental-implants"
        />

        <title>{t("dentalImplants.seo.title")}</title>
        <meta
          name="description"
          content={t("dentalImplants.seo.description")}
        />
        <meta name="keywords" content={t("dentalImplants.seo.keywords")} />
        <meta property="og:title" content={t("dentalImplants.seo.ogTitle")} />
        <meta
          property="og:description"
          content={t("dentalImplants.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://via.placeholder.com/800x450.png?text=Dental+Implants"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:locale"
          content={lang === "ar" ? "ar_AR" : "en_US"}
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: t("dentalImplants.page.faq", {
              returnObjects: true,
            }).map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: { "@type": "Answer", text: faq.answer },
            })),
          })}
        </script>
      </Helmet>

      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {t("dentalImplants.page.title")}
      </h1>
      <h5 className="text-center mb-3">{t("dentalImplants.page.subtitle")}</h5>
      <p className="text-center mb-4">{t("dentalImplants.page.clinic")}</p>
      <p>{t("dentalImplants.page.intro")}</p>

      <h2 className="mt-4">{t("dentalImplants.page.whatIsTitle")}</h2>
      <p>{t("dentalImplants.page.whatIsText")}</p>

      <h2 className="mt-4">{t("dentalImplants.page.benefitsTitle")}</h2>
      <ul>
        {t("dentalImplants.page.benefitsList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("dentalImplants.page.typesTitle")}</h2>
      {["traditional", "immediate", "allOn"].map((type) => (
        <div key={type}>
          <h3 className="mt-3">
            {t(`dentalImplants.page.types.${type}.title`)}
          </h3>
          <p>{t(`dentalImplants.page.types.${type}.text`)}</p>
        </div>
      ))}

      <h2 className="mt-4">{t("dentalImplants.page.treatmentStepsTitle")}</h2>
      <ol>
        {t("dentalImplants.page.treatmentStepsList", {
          returnObjects: true,
        }).map((step, idx) => (
          <li key={idx}>{step}</li>
        ))}
      </ol>

      <h2 className="mt-4">
        {t("dentalImplants.page.oneDaySuitabilityTitle")}
      </h2>
      <p>{t("dentalImplants.page.oneDaySuitabilityText")}</p>

      <h2 className="mt-4">{t("dentalImplants.page.careTitle")}</h2>
      <ul>
        {t("dentalImplants.page.careList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("dentalImplants.page.whyChooseTitle")}</h2>
      <ul>
        {t("dentalImplants.page.whyChooseList", { returnObjects: true }).map(
          (item, idx) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("dentalImplants.page.doctorMessageTitle")}</h2>
      <p>
        <em>{t("dentalImplants.page.doctorMessageText")}</em>
      </p>

      <footer className="mt-4">
        <HashLink to="/#services" className="btn btn-outline-secondary">
          {t("dentalImplants.page.backButton")}
        </HashLink>
      </footer>
    </div>
  );
};

export default DentalImplants;
